import { render, staticRenderFns } from "./ProjectHeaderT.vue?vue&type=template&id=0d895bcf&scoped=true&"
import script from "./ProjectHeaderT.vue?vue&type=script&lang=ts&"
export * from "./ProjectHeaderT.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectHeaderT.vue?vue&type=style&index=0&id=0d895bcf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d895bcf",
  null
  
)

export default component.exports